export const TaskStatusEnum = {
    'TREATED': 'TREATED',
    'PENDING': 'PENDING'
};
